import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AutomotiveBG from "../../assets/images/pngs/Automotive/automotive-bg.png";
import BriaButton from "../../components/common/BriaButton/BriaButton.tsx";
import RouterConstants from "../../constants/RouterConstants.ts";
import useSecureNavigate from "../../hooks/useSecureNavigate.tsx";
import { useAppStore } from "../../hooks/useStores.tsx";
import styles from "./Automotive.module.scss";
import AutomotiveBestPracticesButton from "./Buttons/AutomotiveBestPracticesButton/AutomotiveBestPracticesButton.tsx";

const Automotive = () => {
	const { t } = useTranslation("translation", { keyPrefix: "automotiveApp" });
	const { uiStore } = useAppStore();
	const navigate = useSecureNavigate();
	const location = useLocation();
	useEffect(() => {
		uiStore.showSideBar();
	}, []);

	useEffect(() => {
		uiStore.showBackButton(location?.state?.from, undefined, undefined, undefined, undefined, undefined, undefined);
		return () => {
			uiStore.hideBackButton();
		};
	}, []);

	return (
		<Box className={styles.container}>
			<Box className={styles.contentWrapper}>
				<Box className={styles.content}>
					<Typography className={styles.title} dangerouslySetInnerHTML={{ __html: t("landingTitle") }} />
					<Typography
						className={styles.subTitle}
						dangerouslySetInnerHTML={{ __html: t("landingSubtitle") }}
					/>
					<Box className={styles.actions}>
						<BriaButton
							buttonType="primaryMedium"
							onClick={() =>
								navigate(RouterConstants.NEW_AUTOMOTIVE_PROJECT.fullPath, {
									state: { from: location.state?.from },
								})
							}
							className={styles.actionBtn}
						>
							{t("startNewProject")}
						</BriaButton>
						<BriaButton
							buttonType="secondaryMedium"
							onClick={() =>
								navigate(RouterConstants.AUTOMOTIVE_PROJECTS.fullPath, {
									state: { from: location.state?.from },
								})
							}
						>
							{t("manageProjects")}
						</BriaButton>
						<AutomotiveBestPracticesButton />
					</Box>
				</Box>
			</Box>

			<Box className={styles.bgImages}>
				<img src={AutomotiveBG} />
			</Box>
		</Box>
	);
};

export default observer(Automotive);
